<div class="pad-L primary">
	<div class="flex-align-center gap-S f-d-r mb-m">
		<app-chips [square]="true" [size]="'xl'">
			<img src="assets/icons/layers-three-02.svg" class="filter-grey" height="25px">
		</app-chips>
		<div class="flex-column gap-XS ml-s">
			<div class="font-L fw-700">{{ 'page.appDetails.overview.functionalCapacities.add' | translate }}</div>
			<div class="font-M fw-300">{{ 'page.appDetails.overview.functionalCapacities.addSubtitle' | translate }}</div>
		</div>
	</div>
	<div class="flex flex-align-center gap-S mb-m">
		<app-text-input *ngIf="mode === 'select' || mode ==='delete'" class="w-100" [disabled]="!initialized" [placeholder]="'page.appDetails.overview.functionalCapacities.search' | translate" [input]="searchInput"></app-text-input>
		<div *ngIf="mode === 'select'" style="padding: 3px;" class="flex-align-center filter-bar bkg-white b-radius-6">
			<app-text-button style="width: 35px; height: 35px;" type="default" color="primary"
							 panelClass="h-100-imp pad-0-imp"
							 [matMenuTriggerFor]="dotsMenu"
							 [disabled]="!initialized"
							 [loading]="_loading">
				<div class="flex-center">
					<img src="assets/icons/dots-vertical.svg" height="18" alt=""/>
				</div>
			</app-text-button>
			<mat-menu #dotsMenu class="mat-menu-dots"
					  xPosition="before" yPosition="below">
				<div class="flex-column gap-XS" style="padding: 6px;">
					<div *ngIf="tenantFunctionalCapacities.length > 0" (click)="toggleMode('delete', $event); $event.stopPropagation();" class="flex-align-center gap-S b-radius-6 c-p menu-elt" style="padding: 5px 10px">
						<img src="assets/icons/trash-03.svg" width="14" class="filter-white" alt=""/>
						<div class="font-M fw-500 white">{{ 'global.multiSelect.delete.deleteElements' | translate }}</div>
					</div>
					<div  (click)="toggleMode('create-group', $event); $event.stopPropagation();" class="flex-align-center gap-S b-radius-6 c-p menu-elt" style="padding: 5px 10px">
						<img src="assets/icons/plus.svg" width="14" class="filter-white" alt=""/>
						<div class="font-M fw-500 white">{{ 'page.appDetails.overview.functionalCapacities.addAGroup' | translate }}</div>
					</div>
					<div *ngIf="tenantFunctionalCapacities.length > 0" (click)="toggleMode('create-child', $event); $event.stopPropagation();" class="flex-align-center gap-S b-radius-6 c-p menu-elt" style="padding: 5px 10px">
						<img src="assets/icons/plus.svg" width="14" class="filter-white" alt=""/>
						<div class="font-M fw-500 white">{{ 'page.appDetails.overview.functionalCapacities.addACapacity' | translate }}</div>
					</div>
				</div>
			</mat-menu>
		</div>
		<div *ngIf="mode === 'delete'" style="width: 48px; height: 41px;">
			<app-text-button type="stroked" color="accent"
							 panelClass="h-100-imp pad-0-imp"
							 (click)="toggleMode('select', $event);"
							 [tooltip]="'global.multiSelect.delete.cancel' | translate"
							 tooltipPosition="right"
							 [disabled]="!initialized"
							 [loading]="_loading">
				<div class="flex-center">
					<img src="assets/icons/cross-black.svg" height="18" alt=""/>
				</div>
			</app-text-button>
		</div>
	</div>
	<div *ngIf="mode === 'create-group'" style="max-height: calc(80vh - 256px); min-height: calc(80vh - 256px); overflow: auto">
		<form class="flex-column gap-L" [formGroup]="createFunctionalCapacityGroupFormGroup">
			<div class="flex-column gap-S flex-center">
				<div class="selected-icon-container flex-center">
					<img width="30" [src]="'assets/icons/functional-capacities/' + createFunctionalCapacityGroupFormGroup.get('icon')!.value + '.svg'" class="filter-accent" alt=""/>
				</div>
				<span class="grey text-underline c-p" (click)="showIcons = !showIcons">{{ 'page.appDetails.overview.functionalCapacities.changeIcon' | translate }}</span>
				<div class="icon-selection-container" *ngIf="showIcons" style="padding: 10px 15px;">
					<div *ngFor="let icon of icons" class="func-icon-btn flex-center c-p" [class.icon-selected]="icon === createFunctionalCapacityGroupFormGroup.get('icon')!.value " (click)="createFunctionalCapacityGroupFormGroup.get('icon')!.setValue(icon)">
						<img width="20" [src]="'assets/icons/functional-capacities/' + icon + '.svg'" class="filter-accent" alt=""/>
					</div>
				</div>
			</div>
			<div class="flex-column gap-XS overflow-hidden">
				<div class="font-M fw-500 grey">{{ 'page.appDetails.overview.functionalCapacities.groupName' | translate }}*</div>
				<app-text-input [input]="$any(createFunctionalCapacityGroupFormGroup.get('name'))"
								[placeholder]="'page.appDetails.overview.functionalCapacities.nameInput' | translate"></app-text-input>
			</div>
		</form>
	</div>
	<div *ngIf="mode === 'create-child'" style="max-height: calc(80vh - 256px); min-height: calc(80vh - 256px); overflow: auto">
		<form class="flex-column gap-L" [formGroup]="createFunctionalCapacityGroupFormGroup">
			<div class="flex-column gap-XS overflow-hidden">
				<div class="font-M fw-500 grey">{{ 'page.appDetails.overview.functionalCapacities.group' | translate }}*</div>
				<app-multi-select [inputControl]="$any(createFunctionalCapacityFormGroup.get('group'))">
					<app-select-trigger appearance="field">{{ createFunctionalCapacityFormGroup.get('group')!.value?.name || '-' }}</app-select-trigger>
					<app-select-option *ngFor="let group of tenantFunctionalCapacities" [value]="group">
						<div class="flex-align-center gap-S">
							<img *ngIf="group.icon" width="16" [src]="'assets/icons/functional-capacities/' + group.icon + '.svg'" alt=""/>
							<span>{{ group.name }}</span>
						</div>
					</app-select-option>
				</app-multi-select>
			</div>
			<div class="flex-column gap-XS overflow-hidden">
				<div class="font-M fw-500 grey">{{ 'page.appDetails.overview.functionalCapacities.name' | translate }}</div>
				<app-text-input [input]="$any(createFunctionalCapacityFormGroup.get('name'))"
								[placeholder]="'page.appDetails.overview.functionalCapacities.nameInput' | translate"></app-text-input>
			</div>
		</form>
	</div>
	<div *ngIf="mode === 'select' || mode === 'delete'" class="bg-rounded-2 custom-scrollbar" style="max-height: calc(80vh - 300px); min-height: calc(80vh - 300px);">
		<div *ngIf="initialized">
			<div *ngFor="let group of filteredFunctionalCapacities">
				<div class="pad-L flex-justify-center flex-column">
					<div style="height: 20px" class="flex-space-between">
						<div class="disp-f a-i-c gap-S overflow-hidden">
							<div (click)="toggleAccordion(group)" class="unfold-button c-p flex-center">
								<img src="assets/icons/arrow-right-black.svg" class="filter-grey accordion-image" [style.rotate]="group.expanded ? '90deg' : '0deg'" alt=""/>
							</div>
							<img *ngIf="group.icon" width="16" class="filter-primary" [src]="'assets/icons/functional-capacities/' + group.icon + '.svg'" alt=""/>
							<span class="font-M text-overflow-ellipsis">{{ group.name }}</span>
						</div>
						<mat-checkbox *ngIf="mode === 'delete'" class="custom-checkbox custom-checkbox-2"
									  [checked]="isCapacitySelectedForDelete(group)"
									  [indeterminate]="isParentIndeterminate(group)"
									  (change)="onDeleteSelectionChange(group, $event)"></mat-checkbox>
					</div>

					<div [@expandCollapse]="group.expanded ? 'expanded' : 'collapsed'" class="pad-left-M overflow-hidden">
						<div class="functional-capacity-list flex-column flex-justify-center gap-M pad-left-M">
							<div *ngFor="let functionalCapacity of group.children">
								<div class="flex-align-center flex-space-between" style="height: 25px">
									<span class="text-overflow-ellipsis">{{ functionalCapacity.name }}</span>
									<mat-checkbox class="custom-checkbox" *ngIf="mode === 'delete'"
												  [checked]="isCapacitySelectedForDelete(functionalCapacity)"
												  (change)="onDeleteSelectionChange(functionalCapacity, $event)"></mat-checkbox>
									<mat-checkbox class="custom-checkbox" *ngIf="mode !== 'delete'"
												  [checked]="isFunctionalCapacitySelected(functionalCapacity)"
												  [disabled]="isSelectModeCheckboxDisabled(functionalCapacity)"
												  (change)="onSelectModeSelectionChange(functionalCapacity, $event)"></mat-checkbox>
								</div>
							</div>
							<div *ngIf="group.children.length <= 0">
								<div class="flex-center">
									<span class="grey">{{ 'page.appDetails.overview.functionalCapacities.noFunctionalCapacity' | translate }}</span>
								</div>
							</div>
						</div>
					</div>
				</div>
				<hr *ngIf="group !== filteredFunctionalCapacities[filteredFunctionalCapacities.length - 1]">
			</div>
			<div *ngIf="filteredFunctionalCapacities.length <= 0 && tenantFunctionalCapacities.length > 0" class="flex-center flex-column gap-M" style="height: calc(80vh - 300px);">
				<img src="assets/illustrations/empty-capacity.svg">
				<span class="grey">{{ 'page.appDetails.overview.functionalCapacities.noFunctionalCapacitySearch' | translate }}</span>
			</div>
			<div *ngIf="tenantFunctionalCapacities.length <= 0" class="flex-center flex-column gap-M" style="height: calc(80vh - 308px);">
				<img src="assets/illustrations/empty-capacity.svg">
				<span class="grey">{{ 'page.appDetails.overview.functionalCapacities.noFunctionalCapacity2' | translate }}</span>
				<app-text-button
					(click)="toggleMode('create-group', $event)"
					type="flat">
					{{ 'page.appDetails.overview.functionalCapacities.createAGroup' | translate }}
				</app-text-button>
			</div>
		</div>
		<app-dashboard-page-loader *ngIf="!initialized"></app-dashboard-page-loader>
	</div>
	<div class="w-100 disp-f f-d-r j-c-sb a-i-c mt-l gap-M">
		<app-text-button *ngIf="mode === 'select' || mode === 'delete'" class="w-50" type="stroked" (click)="onDismiss()">{{ 'button.cancel' | translate }}</app-text-button>
		<app-text-button *ngIf="mode === 'create-child' || mode === 'create-group'" class="w-50" type="stroked" (click)="toggleMode('select', $event)">{{ 'page.appDetails.overview.functionalCapacities.back' | translate }}</app-text-button>
		<app-text-button *ngIf="mode === 'select'" class="w-50" type="flat" (click)="updateCapacities()">{{ 'button.save' | translate }}</app-text-button>
		<app-text-button *ngIf="mode === 'create-child'" class="w-50" type="flat" [disabled]="createFunctionalCapacityFormGroup.invalid" (click)="createFunctionalCapacity()">{{ 'button.save' | translate }}</app-text-button>
		<app-text-button *ngIf="mode === 'create-group'" class="w-50" type="flat" [disabled]="createFunctionalCapacityGroupFormGroup.invalid" (click)="createFunctionalCapacityGroup()">{{ 'button.save' | translate }}</app-text-button>
		<app-text-button
			*ngIf="mode === 'delete'"
			color="warn"
			type="flat"
			class="w-50"
			[disabled]="functionalCapacitiesToDelete.size <= 0"
			(click)="deleteFunctionalCapacities()">
			{{ 'global.multiSelect.delete.1short' | translate }} {{ functionalCapacitiesToDelete.size }} {{ 'global.multiSelect.delete.2' | translate }}
		</app-text-button>
	</div>
</div>
